import React from "react";
import Chart from "react-apexcharts";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import moment from "moment";

export default function LineChart(props: any) {
  const {
    whiteLabels,
    graphData,
    color,
    carouselData,
    hideTooltip,
    coinGraph,
    modalData,
    balanceChartData,
    tableBodyGraph,
  } = props;

  const formatData = modalData?.x?.map((el: Date) => {
    return moment(el).utc().fromNow();
  });

  // let dynamicColor;
  const loadSeriesData = () => {
    if (carouselData) {
      return carouselData?.y;
    }
    if (coinGraph) {
      return coinGraph?.yLine;
    }
    if (modalData) {
      return modalData?.y;
    }
    if (balanceChartData) {
      return balanceChartData?.y;
    }
    if (graphData) {
      return graphData?.y;
    }
    if (tableBodyGraph) {
      return tableBodyGraph?.y;
    }
  };
  const seriesData = loadSeriesData();

  const data: any = {
    series: [
      {
        name: "",
        data: seriesData,
      },
    ],
    options: {
      tooltip: {
        enabled: hideTooltip ? false : true,
        x: {
          show: true,
        },
      },
      yaxis: {
        show: false,
        labels: {
          formatter: function (value: any) {
            return formatCurrency(value, "AUD", { type: "$" });
          },
        },
      },
      chart: {
        type: "line",
        sparkline: {
          enabled: true,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: [color],
      stroke: {
        show: true,
        curve: "smooth",
        width: 1,
      },
      grid: {
        show: false,
      },
      xaxis: {
        type: "category",
        labels: {
          show: false,
          style: {
            colors: whiteLabels
              ? ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]
              : ["#545454"],
            fontSize: "12px",
            fontWeight: 600,
            fontFamily: "Roobert",
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 3,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        categories: formatData ? formatData : [],
      },
    },
  };
  return (
    <div className="line">
      <Chart
        options={data.options}
        series={data.series}
        type="line"
        height={props.height}
        width={props.width}
      />
    </div>
  );
}
